// ? Getting the date
const getCurrentMonth = () => {
  const month = new Date().getMonth() + 1;
  if (month < 10) return `0${month}`;
  return month;
};

const getCurrentDay = () => {
  const day = new Date().getDate();
  if (day < 10) return `0${day}`;
  return day;
};

const currentDate = `${new Date().getFullYear()}-${getCurrentMonth()}-${getCurrentDay()}`;
const nextYear = `${
  new Date().getFullYear() + 1
}-${getCurrentMonth()}-${getCurrentDay()}`;
const lastYear = `${
  new Date().getFullYear() - 1
}-${getCurrentMonth()}-${getCurrentDay()}`;

// ? Base url
const base_url = "https://api.rawg.io/api/";

// ? Popular Games

const popular_games = `games?dates=${lastYear},${currentDate}&ordering=-rating&page_size=`;
const upcoming_games = `games?dates=${currentDate},${nextYear}&ordering=-added&page_size=9`;
const newGames = `games?dates=${lastYear},${currentDate}&ordering=-released&page_size=9`;

export const popularGamesURL = () => `${base_url}${popular_games}`;
export const upcomingGamesURL = (length) =>
  `${base_url}${upcoming_games}${length}`;
export const newGamesURL = () => `${base_url}${newGames}`;
// ? Game details
export const gameDetailsURL = (id) => `${base_url}games/${id}`;
// ? Game screenShots
export const gameScreenshotURL = (id) => `${base_url}games/${id}/screenshots`;
// ? Searched games
export const searchedURL = (gameName) =>
  `${base_url}games?search=${gameName}&page_size=20`;
